import { render, staticRenderFns } from "./FantasySummary.vue?vue&type=template&id=6d7a795f&"
import script from "./FantasySummary.vue?vue&type=script&lang=js&"
export * from "./FantasySummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports